import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.188 10.156v-3.63a.818.818 0 0 0-.813-.813H5.156a1.62 1.62 0 0 0-1.625 1.625v2.006c0 .914.711 1.625 1.625 1.625h1.219a.818.818 0 0 0 .813-.813Zm-1.22-.406h-.812a.401.401 0 0 1-.406-.406V7.338c0-.229.178-.406.406-.406h.813V9.75ZM8 1.625c-3.63 0-6.398 3.021-6.5 6.5v.406c0 .229.178.406.406.406h.407a.418.418 0 0 0 .406-.406v-.406C2.719 5.23 5.08 2.844 8 2.844c2.895 0 5.281 2.386 5.281 5.281h-.025l.025 4.215c0 .61-.482 1.066-1.091 1.066H9.625c0-.66-.559-1.219-1.219-1.219h-.812c-.686 0-1.219.56-1.219 1.22 0 .685.533 1.218 1.219 1.218h4.596c1.269 0 2.31-1.016 2.31-2.285V8.125c-.127-3.479-2.895-6.5-6.5-6.5Zm2.844 9.344a1.62 1.62 0 0 0 1.625-1.625V7.338c0-.889-.737-1.625-1.625-1.625H9.625a.802.802 0 0 0-.813.812v3.631c0 .457.356.813.813.813h1.219Zm-.813-4.037h.813c.203 0 .406.177.406.406v2.006a.418.418 0 0 1-.406.406h-.813V6.932Z",
      fill: "currentColor"
    })
  }));
};
export default SvgComponent;